<template>
  <div ref="adicionalesHoteleria" v-resize="configPlano">
    <v-container fluid class="pt-1">
      <v-layout row wrap>
        <v-flex xs12 v-if="false">
          <v-alert :value="true" type="info" color="light-blue lighten-2"
            >Mensaje de explicación para la selección de servicios adiconales</v-alert
          >
        </v-flex>
        <v-flex xs12 v-for="(h, idxh) in servicios.hoteles" :key="idxh">
          <v-card color="white" class="black--text mb-4 elevation-1">
            <v-card-title primary-title>
              <div>
                <div class="headline">
                  <p class="mb-0">{{ h.nombre }}</p>
                </div>
                <span>
                  Desde {{ h.in | formatDMY }} hasta
                  {{ h.out | formatDMY }}
                </span>
              </div>
            </v-card-title>
            <v-card-text>
              <v-container fluid class="pa-0">
                <v-layout column>
                  <v-flex xs12>
                    <v-card
                      v-for="(hab, idhab) in h.habitaciones"
                      :key="idhab"
                      class="mb-4 elevation-5"
                      color="grey lighten-3"
                    >
                      <v-container fluid grid-list-lg>
                        <p class="text-xs-center font-weight-regular title">
                          Habitación {{ idhab + 1 }}:
                          {{ hab.habitacion.nombre.toUpperCase() }}
                        </p>
                        <ContenedorComidasHoteles
                          v-if="hab.habitacion.comida"
                          class="mb-3"
                          :alert="tieneErrores('c', hab.habitacion.comparador)"
                          :loading="loadingComidas"
                          :obligatorio="_$toBoolean(hab.habitacion.comida_obligatorio)"
                          :comparador="hab.habitacion.comparador"
                          :comidasHabitacion="hab.habitacion.comidas"
                          :allComidas="adicionales.comidas"
                        ></ContenedorComidasHoteles>
                        <ContenedorRsPasesHoteles
                          v-if="hab.habitacion.pase"
                          :alert="tieneErrores('t', hab.habitacion.comparador)"
                          :loading="loadingPases"
                          :ticketsHabitacion="hab.habitacion.tickets"
                          :obligatorio="_$toBoolean(hab.habitacion.pase_obligatorio)"
                          :data="{
                            pases: adicionales.tickets.filter(t => t.comparador == hab.habitacion.comparador),
                            proveedor: h.proveedor
                          }"
                        ></ContenedorRsPasesHoteles>
                        <div v-else>
                          <p class="font-weight-regular">
                            <v-icon color="yellow darken-3" class="black--text">fas fa-info-circle</v-icon>Esta
                            habitación no posee servicios adicionales para agregar
                          </p>
                        </div>
                      </v-container>
                    </v-card>
                  </v-flex>
                  <v-flex xs12 v-if="loadingTraslados">
                    <v-card-text>
                      <p class="text-xs-center">Buscando traslados</p>
                      <v-progress-linear indeterminate color="red" class="mb-0" height="1"></v-progress-linear>
                    </v-card-text>
                  </v-flex>
                  <v-flex xs12 v-else>
                    <v-card class="mb-4 elevation-5" color="grey lighten-3" v-if="adicionales.traslados.length > 0">
                      <v-container fluid grid-list-lg>
                        <v-layout row wrap>
                          <v-flex xs12 v-if="false">
                            <v-alert :value="true" type="info" color="light-blue lighten-2">
                              Mensaje de explicación para la selección de traslados
                            </v-alert>
                          </v-flex>
                          <v-flex xs12>
                            <div v-if="!_inactive">
                              <ListadoTraslados
                                :data="buscarTrasladosByHotel(h.unico_carrito, h.in, h.out)"
                                :seleccionados="buscarSeleccionado(h.unico_carrito)"
                              ></ListadoTraslados>
                            </div>
                          </v-flex>
                        </v-layout>
                      </v-container>
                    </v-card>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-card-text>
            <v-divider :key="`divider-${idxh}`"></v-divider>
          </v-card>
        </v-flex>
        <v-flex xs12 v-if="mostrarAdicionales()">
          <v-card>
            <v-card-text>
              <v-alert :value="true" type="info" color="light-blue lighten-2" class="mb-2" v-if="false"
                >Mensaje de explicación para la selección de tickets</v-alert
              >
              <v-card color="grey lighten-3">
                <v-card-title primary-title>
                  <div class="headline">Tickets adicionales</div>
                </v-card-title>
                <v-card-text>
                  <BuscadorPases
                    :inicialIsRs="false"
                    :soloTickets="true"
                    :plano="plano"
                    :enfocar="true"
                  ></BuscadorPases>
                </v-card-text>
              </v-card>
            </v-card-text>
          </v-card>
        </v-flex>
        <v-flex xs12 sm12 class="pa-2" v-if="faltantes.length > 0">
          <ul class="ul-not-dot-as">
            <li v-for="(p, pindx) in pendientes" :key="`${pindx}-pen`">
              <p class="red--text darken-1 mb-0 font-weight-bolder">{{ p }}</p>
            </li>
          </ul>
        </v-flex>
        <v-flex xs12 sm3 v-if="!boton.visible">
          <v-btn block v-bind:class="boton.classObject" class="white--text" @click="goTo">{{ boton.texto }}</v-btn>
        </v-flex>
      </v-layout>
    </v-container>
  </div>
</template>

<script>
// @ is an alias to /src
import { mapGetters } from "vuex"
import AxiosHandler from "@/assets/js/class/AxiosHandler.js"
import ListadoTraslados from "@/components/traslados/ListadoTraslados.vue"
import ContenedorRsPasesHoteles from "@/components/pases/ContenedorRsPasesHoteles.vue"
import ContenedorComidasHoteles from "@/components/comidas/ContenedorComidasHoteles.vue"
import BuscadorPases from "@/components/pases/BuscadorPases.vue"
import store from "@/store/index.js"
import { mapMutations } from "vuex"
export default {
  name: "adicionalesHoteleria",
  components: {
    ListadoTraslados,
    ContenedorRsPasesHoteles,
    BuscadorPases,
    ContenedorComidasHoteles
  },
  mounted() {},
  created() {
    //  this.buscarAdicionales();
  },
  activated() {
    if (!this._inactive) {
      this.submitted = false
      this.sinAdicionales = false
      this.buscarAdicionales()
      let boton = this.prepararContinua()
      this.$store.dispatch("carrito/saveBoton", boton)
    }
  },
  methods: {
    armarConsultasAdicionales() {
      let _this = this
      this.rqs = []
      this.rqsTkts = []
      this.rqsComidas = []
      this.servicios.hoteles.forEach(h => {
        _this.armarRqTicketsComidas(h.in, h.habitaciones, h.proveedor, h.out, h.id)
        if (_this.rqs.length === 0) {
          _this.newRq(h.in, h.id, h.destinoBuscador, 0, 0, 0, h.nombre, h.unico_carrito, h.out)
          _this.generarAdlChd(h.habitaciones, 0)
          return
        }
        let indice = this.rqs.findIndex(r => {
          return h.checkin === r.in && h.id === r.hotel_id
        })
        if (indice != -1) {
          _this.generarAdlChd(h.habitaciones, indice)
          return
        }
        _this.newRq(h.in, h.id, h.destinoBuscador, 0, 0, 0, h.nombre, h.unico_carrito, h.out)
        _this.generarAdlChd(h.habitaciones, _this.rqs.length - 1)
      })
    },
    generarAdlChd(habitaciones, indexRq) {
      let _this = this
      habitaciones.forEach(h => {
        _this.rqs[indexRq].adl = _this.rqs[indexRq].adl + parseInt(h.habitacion.tarifas.tarifa["@attributes"].adl)

        try {
          if (h.habitacion.menores.edades.edad === undefined) {
            return
          }
          let edades = this.toArray(h.habitacion.menores.edades.edad)
          edades.forEach(e => {
            if (parseInt(e) > 11) {
              _this.rqs[indexRq].adl++
              return
            }
            if (parseInt(e) < 3) {
              _this.rqs[indexRq].inf++
              return
            }
            _this.rqs[indexRq].chd++
          })
        } catch (e) {
          console.log(e)
        }
      })
    },
    newRq(checkin, hotel_id, destino, adl, chd, inf, nombre_hotel, unico_carrito, out) {
      this.rqs.push({
        checkin: checkin,
        hotel_id: hotel_id,
        destino: destino,
        adl: adl,
        chd: chd,
        inf: inf,
        nombre_hotel: nombre_hotel,
        unico_carrito: unico_carrito,
        checkout: out,
        isTarifario: false
      })
    },
    async getTraslados() {
      this.loadingTraslados = true
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let axios = new AxiosHandler()
      axios.setPassportHandler(this.$passporthandler)
      axios.prepare(process.env.VUE_APP_ASBACK + "/api/get-traslados", header, this.rqs)
      axios.overlay(false)
      await axios.exe()
      this.adicionales["traslados"] = axios.getData().traslados
      this.loadingTraslados = false
    },
    buscarTrasladosByHotel(unico, checkin, checkout) {
      const traslados = this.adicionales.traslados.find(t => t.unico_carrito === unico)
      if (traslados === undefined) {
        return
      }

      return {
        unico_hotel: unico,
        traslados: this.toArray(traslados.rs.ticket),
        hotel: { nombre: traslados.hotel, checkin: checkin, checkout: checkout }
      }
    },
    armarRqTicketsComidas(checkin, habitaciones, proveedor, checkout, idHotel) {
      const _this = this
      habitaciones.forEach(h => {
        const adultos =
          parseInt(h.habitacion.tarifas.tarifa["@attributes"].adl) +
          parseInt(h.habitacion.tarifas.tarifa["@attributes"].jr)
        const chds = parseInt(h.habitacion.tarifas.tarifa["@attributes"].chd)

        if (h.habitacion.pase) {
          this.rqTicket(
            checkin,
            adultos,
            5,
            null,
            1,
            null,
            chds,
            h.habitacion.rq.destino,
            0,
            h.habitacion.comparador,
            h.habitacion.promocion,
            proveedor,
            h.habitacion.ticketTipo
          )
        }
        if (h.habitacion.comida) {
          this.rqComidas(checkin, checkout, adultos, chds, 0, idHotel, h.habitacion.regimen, h.habitacion.comparador)
        }
      })
    },
    rqTicket(
      checkin,
      adl,
      dias,
      breve,
      desde,
      flexit,
      chd,
      destino,
      jr,
      comparador,
      codigo,
      proveedor,
      ticketTipo = 0
    ) {
      this.rqsTkts.push({
        checkin: checkin,
        adl: adl,
        dias: dias,
        breve: breve,
        desde: desde,
        flexit: flexit,
        chd: chd,
        destino: destino,
        jr: jr,
        codigo: codigo,
        comparador: comparador,
        proveedor: proveedor,
        ticketTipo: ticketTipo
      })
    },
    buscarAdicionales() {
      let _this = this
      this.armarConsultasAdicionales()
      this.getTraslados()
      this.faltantes = []
      if (this.rqsTkts.length > 0 && this.adicionales["tickets"].length === 0) {
        this.getPases()
      }
      if (this.rqsComidas.length > 0 && this.adicionales["comidas"].length === 0) {
        this.getComidas()
      }
    },
    async getPases() {
      this.loadingPases = true
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let axios = new AxiosHandler()
      axios.setPassportHandler(this.$passporthandler)
      axios.prepare(process.env.VUE_APP_ASBACK + "/api/get-pases", header, this.rqsTkts)
      axios.overlay(false)
      await axios.exe()
      this.adicionales["tickets"] = axios.getData().disponibilidad
      this.loadingPases = false
    },
    async getComidas() {
      this.loadingComidas = true
      var header = this.$passporthandler.prepareHeader()
      if (!(typeof header.auth === "undefined")) {
        return this.$router.replace({ name: "login" })
      }
      let axios = new AxiosHandler()
      axios.setPassportHandler(this.$passporthandler)
      axios.prepare(process.env.VUE_APP_ASBACK + "/api/get-comidas", header, this.rqsComidas)
      axios.overlay(false)
      await axios.exe()
      this.adicionales["comidas"] = axios.getData()
      this.loadingComidas = false
    },
    buscarSeleccionado(unico_carrito) {
      const lugar = this.servicios.traslados.find(t => t.unico_hotel === unico_carrito)
      if (lugar == undefined) {
        return []
      }
      const seleccionados = lugar.traslados.map(t => {
        return { direccion: t.direccion, idTarifa: t.idTarifa }
      })
      return seleccionados
    },
    configPlano() {
      if (this.$refs.adicionalesHoteleria == undefined) {
        return
      }
      let width = this.$refs.adicionalesHoteleria.clientWidth
      this.plano = "row"
      if (width <= 400 && width != 0) {
        this.plano = "column"
      }
    },
    mostrarAdicionales() {
      if (
        this.servicios.hoteles.some(
          h => parseInt(h.proveedor) === 11 || parseInt(h.proveedor) === 9 || parseInt(h.proveedor) === 6156
        )
      ) {
        return true
      }
      return false
    },
    validaRs() {
      let redir = true
      if (this.loadingPases || this.loadingTraslados) {
        return
      }
      if (Array.isArray(this.adicionales["traslados"]) && this.adicionales["traslados"].length > 0) {
        redir = false
      }
      if (Array.isArray(this.adicionales["tickets"]) && this.adicionales["tickets"].length > 0) {
        redir = false
      }
      if (redir) {
        this.showToasted(
          "No se consiguieron servicios adicionales para la habitación o habitaciones que seleccionó.",
          "warning",
          7000
        )
        // Debe mantenerse como replace ya que al no servios adicionales redireje directo a la carga de los pasajeros, en caso de hacer click back lo redirija al resultado
        // de disponibiliad
        this.$router.replace({ name: "pasajerosCupoAgencias" })
      }
    },
    prepararContinua() {
      let btnmsg = "¡Faltan servicios por seleccionar!"
      let variant = "orange"
      let disabled = true
      let goto = null
      // Valida que todas las habitaciones tengan los tickets seleccionados en caso de ser obligatorio
      const continua = this.servicios.hoteles.every(h => {
        return h.habitaciones.every(hab => {
          if (!hab.habitacion.pase_obligatorio) {
            return true
          }
          const tiene = hab.habitacion.tickets.length === 0 ? false : true
          if (!tiene) {
            btnmsg = "¡Faltan tickets por seleccionar!"
          }
          return tiene
        })
      })
      if (continua) {
        btnmsg = "Continuar"
        variant = "orange"
        disabled = false
        goto = "pasajerosCupoAgencias"
      }
      const boton = this._$toBotonCarrito(btnmsg, goto, variant, disabled, false)
      return boton
    },
    limpiando() {
      this.adicionales = { traslados: [], tickets: [], comidas: [] }
      this.borrarAdicionales()
    },
    ...mapMutations("carrito", {
      borrarAdicionales: "borrarAdicionales"
    }),
    goTo() {
      this.submitted = true
      if (this.faltantes.length === 0) {
        this.doGoTo()
        return
      }
    },
    doGoTo() {
      this.$router.push({ name: this.boton.goto })
    },
    rqComidas(checkin, checkout, adl, chd, jr, idHotel, idRegimen, comparador) {
      this.rqsComidas.push({
        checkin,
        checkout,
        adl,
        chd,
        jr,
        idHotel,
        idRegimen,
        comparador,
        moneda: "USD"
      })
    },
    tomarComida(comparador) {
      const encontrado = this.adicionales.comidas.find(c => (c.comparador = comparador))
      if (encontrado == undefined) {
        return null
      }
      return encontrado
    },
    tieneErrores(tipo, comparador) {
      return this.faltantes.some(f => f.tipo === tipo && f.comparador === comparador && this.submitted)
    }
  },
  data() {
    return {
      rqs: [],
      adicionales: { traslados: [], tickets: [], comidas: [] },
      activeTab: 0,
      rqsTkts: [],
      openModalCarrito: false,
      loadingTraslados: false,
      loadingPases: false,
      plano: "row",
      sinAdicionales: false,
      rqsComidas: [],
      loadingComidas: false,
      faltantes: [],
      submitted: false
    }
  },
  computed: {
    ...mapGetters("carrito", {
      servicios: "cartServicios",
      cantServicios: "getCantidadServicios",
      boton: "getBoton"
    }),
    continua: function() {
      this.faltantes = []
      let btnmsg = "CONTINUAR"
      let variant = "orange"
      let disabled = false
      let goto = null
      // Valida que todas las habitaciones tengan los tickets seleccionados en caso de ser obligatorio
      const continua = this.servicios.hoteles.every(h => {
        return h.habitaciones.every(hab => {
          if (!hab.habitacion.pase_obligatorio && !hab.habitacion.comida_obligatorio) {
            return true
          }
          const tieneT = hab.habitacion.tickets.length === 0 && hab.habitacion.pase_obligatorio ? false : true
          if (!tieneT) {
            this.faltantes.push({
              tipo: "t",
              comparador: hab.habitacion.comparador
            })
          }
          const tieneC = hab.habitacion.comidas.length === 0 && hab.habitacion.comida_obligatorio ? false : true
          if (!tieneC) {
            this.faltantes.push({
              tipo: "c",
              comparador: hab.habitacion.comparador
            })
          }
          return tieneT && tieneC
        })
      })
      if (continua) {
        btnmsg = "Continuar"
        variant = "orange"
        disabled = false
        goto = "pasajerosCupoAgencias"
      }
      const boton = this._$toBotonCarrito(btnmsg, goto, variant, disabled, false)
      return boton
    },
    pendientes: function() {
      let mensajes = []
      const cantidadComidas = this.faltantes.filter(f => f.tipo === "c").length
      const cantidadTickets = this.faltantes.filter(f => f.tipo === "t").length
      if (cantidadComidas) {
        mensajes.push(`Debe seleccionar ${cantidadComidas} comidas que son obligatorias para la habitación`)
      }
      if (cantidadTickets) {
        mensajes.push(`Debe seleccionar ${cantidadTickets} tickets que son obligatorios para la habitación`)
      }

      return mensajes
    }
  },
  watch: {
    continua(newCount) {
      if (!this._inactive) {
        this.$store.dispatch("carrito/saveBoton", newCount)
      }
    },
    loadingPases() {
      this.validaRs()
    },
    loadingTraslados() {
      this.validaRs()
    }
  },
  beforeRouteEnter(to, from, next) {
    const servicios = store.getters["carrito/cartServicios"]
    if (servicios.hoteles.length === 0) {
      next({ name: "inicio" })
      return
    }
    next()
  },
  beforeRouteLeave(to, from, next) {
    if (to.name === "resultadoHoteles" && !this.sinAdicionales) {
      this.limpiando()
      this.sinAdicionales = true
    }
    next()
  }
}
</script>
